<div class="container">
  <div class="header">
    <div class="logo-box">
      <a href="/account/">
        <img [src]="wl_logo_img$ | async" />
      </a>
    </div>
    <div class="header-right"></div>
  </div>
  <div class="signup-wrapper card-align-center">
    <div class="sign-up-title">
      <p class="sub-header">{{ 'SIGN_UP.TITLE' | translate }}</p>
      <div class="top-header">{{ 'SIGN_UP.CREATE_AN_ACCOUNT' | translate }}</div>
    </div>
    <div>
      <div class="form-field-container">
        <form [formGroup]="formGroup">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ 'COMMON.FIELD_LABELS.EMAIL' | translate }}</mat-label>
            <input matInput formControlName="email" required email />
            @if (submitted && f.email.errors) {
              <mat-hint>
                {{ 'SIGN_UP.EMAIL_REQUIRED' | translate }}
              </mat-hint>
            }
          </mat-form-field>
          <div [hidden]="fullFormVisible$ | async">
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{ 'SIGN_UP.BUSINESS_NAME' | translate }}</mat-label>
              <input
                #search
                matInput
                required
                autocapitalize="off"
                spellcheck="false"
                formControlName="businessName"
                placeholder="{{ 'SIGN_UP.SEARCH_BUSINESS' | translate }}"
              />
              @if (submitted && f.businessName.errors) {
                <mat-hint>
                  {{ 'SIGN_UP.REQUIRED_FIELD' | translate }}
                </mat-hint>
              }
            </mat-form-field>
            <div class="powered-by-logo">
              <img [src]="poweredByGoogleLogo" />
            </div>
            <div style="padding-top: 20px">
              <p>
                {{ 'SIGN_UP.CAN_NOT_FIND' | translate }}
                <a (click)="toggleForm()">
                  {{ 'SIGN_UP.MANUAL_CREATE_ACCOUNT' | translate }}
                </a>
                .
              </p>
            </div>
          </div>
          @if (fullFormVisible$ | async) {
            <div class="half-width-fields-container">
              <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                <mat-label>
                  {{ 'COMMON.FIELD_LABELS.FIRST_NAME' | translate }}
                </mat-label>
                <input matInput formControlName="firstName" required />
                @if (submitted && f.firstName.errors) {
                  <mat-hint>
                    {{ 'SIGN_UP.REQUIRED_FIELD' | translate }}
                  </mat-hint>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                <mat-label>
                  {{ 'COMMON.FIELD_LABELS.LAST_NAME' | translate }}
                </mat-label>
                <input matInput formControlName="lastName" required />
                @if (submitted && f.lastName.errors) {
                  <mat-hint>
                    {{ 'SIGN_UP.REQUIRED_FIELD' | translate }}
                  </mat-hint>
                }
              </mat-form-field>
            </div>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{ 'SIGN_UP.BUSINESS_NAME' | translate }}</mat-label>
              <input matInput formControlName="businessName" required />
              @if (submitted && f.businessName.errors) {
                <mat-hint>
                  {{ 'SIGN_UP.REQUIRED_FIELD' | translate }}
                </mat-hint>
              }
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{ 'SIGN_UP.STREET_ADDRESS' | translate }}</mat-label>
              <input matInput formControlName="address" required />
              @if (submitted && f.address.errors) {
                <mat-hint>
                  {{ 'SIGN_UP.REQUIRED_FIELD' | translate }}
                </mat-hint>
              }
            </mat-form-field>
            <div class="half-width-fields-container">
              <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                <mat-label>
                  {{ 'COMMON.FIELD_LABELS.CITY' | translate }}
                </mat-label>
                <input matInput formControlName="city" required />
                @if (submitted && f.city.errors) {
                  <mat-hint>
                    {{ 'SIGN_UP.REQUIRED_FIELD' | translate }}
                  </mat-hint>
                }
              </mat-form-field>
              <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                <mat-label>
                  {{ 'COMMON.FIELD_LABELS.COUNTRY' | translate }}
                </mat-label>
                <mat-select formControlName="country" (selectionChange)="setCountry($event)" required>
                  @for (countryOption of countryOptions$ | async; track countryOption) {
                    <mat-option [value]="countryOption.code">
                      {{ countryOption.name }}
                    </mat-option>
                  }
                </mat-select>
                @if (submitted && f.country.errors) {
                  <mat-hint>
                    {{ 'SIGN_UP.REQUIRED_FIELD' | translate }}
                  </mat-hint>
                }
              </mat-form-field>
            </div>
            <div class="half-width-fields-container">
              <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                <mat-label>{{ 'SIGN_UP.POSTAL/ZIP' | translate }}</mat-label>
                <input matInput formControlName="postalCode" required />
                @if (submitted && f.postalCode.errors) {
                  <mat-hint>
                    {{ 'SIGN_UP.REQUIRED_FIELD' | translate }}
                  </mat-hint>
                }
              </mat-form-field>
              @if (countryConfiguration$ | async; as countryConfig) {
                @if (countryConfig?.zones?.length > 0) {
                  @if (countryConfig && countryConfig.zones) {
                    <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                      <mat-label>{{ 'SIGN_UP.PROV/STATE' | translate }}</mat-label>
                      <mat-select formControlName="stateProv" required>
                        @for (countryZones of countryConfig.zones; track countryZones) {
                          <mat-option [value]="countryZones.code">
                            {{ countryZones.name }}
                          </mat-option>
                        }
                      </mat-select>
                      @if (submitted && f.stateProv.errors) {
                        <mat-hint>
                          {{ 'SIGN_UP.REQUIRED_FIELD' | translate }}
                        </mat-hint>
                      }
                    </mat-form-field>
                  }
                } @else {
                  <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                    <mat-label>{{ 'SIGN_UP.PROV/STATE' | translate }}</mat-label>
                    <mat-select [disabled]="true">
                      <mat-option value="0"></mat-option>
                    </mat-select>
                  </mat-form-field>
                }
              } @else {
                <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                  <mat-label>{{ 'SIGN_UP.PROV/STATE' | translate }}</mat-label>
                  <mat-select [disabled]="true">
                    <mat-option value="0"></mat-option>
                  </mat-select>
                </mat-form-field>
              }
            </div>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-label>{{ 'SIGN_UP.BUSINESS_CATEGORY' | translate }}</mat-label>
              @if (formGroup.controls['businessCategory'].value; as category) {
                <div class="selected-multiples">
                  <va-badge color="light-gray">
                    <div class="badge-content">
                      {{ category.fullName }}
                      <button mat-icon-button type="button" (click)="removeCategory()">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </va-badge>
                </div>
              }
              <input
                matInput
                [formControl]="categoryUiFormControl"
                [matAutocomplete]="categoryAutocomplete"
                (input)="updateCategorySearchTerm($event.target.value)"
                required
              />
              @if (submitted && categoryUiFormControl.errors) {
                <mat-hint>
                  {{ 'SIGN_UP.REQUIRED_FIELD' | translate }}
                </mat-hint>
              }
              <mat-autocomplete
                #categoryAutocomplete="matAutocomplete"
                [displayWith]="nullDisplayFn"
                (optionSelected)="addCategory($event)"
              >
                @for (option of filteredTaxonomies$ | async; track option) {
                  <mat-option [value]="option">
                    {{ option.fullName }}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <div class="half-width-fields-container">
              <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                <mat-label>
                  {{ 'COMMON.FIELD_LABELS.PHONE_NUMBER' | translate }}
                </mat-label>
                <input matInput formControlName="phoneNum" />
              </mat-form-field>
              <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                <mat-label>
                  {{ 'COMMON.FIELD_LABELS.WEBSITE' | translate }}
                </mat-label>
                <input matInput formControlName="website" />
              </mat-form-field>
            </div>
            <div class="half-width-fields-container">
              <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                <mat-label>Facebook URL</mat-label>
                <input matInput formControlName="facebookUrl" />
              </mat-form-field>
              <mat-form-field appearance="outline" floatLabel="always" class="half-width-column">
                <mat-label>Twitter URL</mat-label>
                <input matInput formControlName="twitterUrl" />
              </mat-form-field>
            </div>
          }
          <div class="recaptcha">
            <re-captcha
              (resolved)="captchaCallback($event)"
              siteKey="6LfK63EeAAAAABBijOLrQ0cHqqeaAHALUOTF9V_Y"
            ></re-captcha>
          </div>
          <button
            type="button"
            mat-raised-button
            class="create-button"
            [class.spinner]="saving$ | async"
            [disabled]="(saving$ | async) || !captchaResponse"
            (click)="onSubmit()"
          >
            {{ 'SIGN_UP.CREATE_NEW_ACCOUNT' | translate }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>
